(function () {
  'use strict';

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }

    return target;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  function _createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

    if (!it) {
      if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;

        var F = function () {};

        return {
          s: F,
          n: function () {
            if (i >= o.length) return {
              done: true
            };
            return {
              done: false,
              value: o[i++]
            };
          },
          e: function (e) {
            throw e;
          },
          f: F
        };
      }

      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }

    var normalCompletion = true,
        didErr = false,
        err;
    return {
      s: function () {
        it = it.call(o);
      },
      n: function () {
        var step = it.next();
        normalCompletion = step.done;
        return step;
      },
      e: function (e) {
        didErr = true;
        err = e;
      },
      f: function () {
        try {
          if (!normalCompletion && it.return != null) it.return();
        } finally {
          if (didErr) throw err;
        }
      }
    };
  }

  var _WINDOW = {};
  var _DOCUMENT = {};

  try {
    if (typeof window !== 'undefined') _WINDOW = window;
    if (typeof document !== 'undefined') _DOCUMENT = document;
  } catch (e) {}

  var _ref = _WINDOW.navigator || {},
      _ref$userAgent = _ref.userAgent,
      userAgent = _ref$userAgent === void 0 ? '' : _ref$userAgent;
  var WINDOW = _WINDOW;
  var DOCUMENT = _DOCUMENT;
  var IS_BROWSER = !!WINDOW.document;
  var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
  var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');

  var _familyProxy, _familyProxy2, _familyProxy3, _familyProxy4, _familyProxy5;

  var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
  var PRODUCTION = function () {
    try {
      return "production" === 'production';
    } catch (e) {
      return false;
    }
  }();
  var FAMILY_CLASSIC = 'classic';
  var FAMILY_SHARP = 'sharp';
  var FAMILIES = [FAMILY_CLASSIC, FAMILY_SHARP];

  function familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
      get: function get(target, prop) {
        return prop in target ? target[prop] : target[FAMILY_CLASSIC];
      }
    });
  }
  var PREFIX_TO_STYLE = familyProxy((_familyProxy = {}, _defineProperty(_familyProxy, FAMILY_CLASSIC, {
    'fa': 'solid',
    'fas': 'solid',
    'fa-solid': 'solid',
    'far': 'regular',
    'fa-regular': 'regular',
    'fal': 'light',
    'fa-light': 'light',
    'fat': 'thin',
    'fa-thin': 'thin',
    'fad': 'duotone',
    'fa-duotone': 'duotone',
    'fab': 'brands',
    'fa-brands': 'brands',
    'fak': 'kit',
    'fa-kit': 'kit'
  }), _defineProperty(_familyProxy, FAMILY_SHARP, {
    'fa': 'solid',
    'fass': 'solid',
    'fa-solid': 'solid',
    'fasr': 'regular',
    'fa-regular': 'regular',
    'fasl': 'light',
    'fa-light': 'light'
  }), _familyProxy));
  var STYLE_TO_PREFIX = familyProxy((_familyProxy2 = {}, _defineProperty(_familyProxy2, FAMILY_CLASSIC, {
    'solid': 'fas',
    'regular': 'far',
    'light': 'fal',
    'thin': 'fat',
    'duotone': 'fad',
    'brands': 'fab',
    'kit': 'fak'
  }), _defineProperty(_familyProxy2, FAMILY_SHARP, {
    'solid': 'fass',
    'regular': 'fasr',
    'light': 'fasl'
  }), _familyProxy2));
  var PREFIX_TO_LONG_STYLE = familyProxy((_familyProxy3 = {}, _defineProperty(_familyProxy3, FAMILY_CLASSIC, {
    'fab': 'fa-brands',
    'fad': 'fa-duotone',
    'fak': 'fa-kit',
    'fal': 'fa-light',
    'far': 'fa-regular',
    'fas': 'fa-solid',
    'fat': 'fa-thin'
  }), _defineProperty(_familyProxy3, FAMILY_SHARP, {
    'fass': 'fa-solid',
    'fasr': 'fa-regular',
    'fasl': 'fa-light'
  }), _familyProxy3));
  var LONG_STYLE_TO_PREFIX = familyProxy((_familyProxy4 = {}, _defineProperty(_familyProxy4, FAMILY_CLASSIC, {
    'fa-brands': 'fab',
    'fa-duotone': 'fad',
    'fa-kit': 'fak',
    'fa-light': 'fal',
    'fa-regular': 'far',
    'fa-solid': 'fas',
    'fa-thin': 'fat'
  }), _defineProperty(_familyProxy4, FAMILY_SHARP, {
    'fa-solid': 'fass',
    'fa-regular': 'fasr',
    'fa-light': 'fasl'
  }), _familyProxy4));
  var FONT_WEIGHT_TO_PREFIX = familyProxy((_familyProxy5 = {}, _defineProperty(_familyProxy5, FAMILY_CLASSIC, {
    '900': 'fas',
    '400': 'far',
    'normal': 'far',
    '300': 'fal',
    '100': 'fat'
  }), _defineProperty(_familyProxy5, FAMILY_SHARP, {
    '900': 'fass',
    '400': 'fasr',
    '300': 'fasl'
  }), _familyProxy5));
  var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
  var DUOTONE_CLASSES = {
    GROUP: 'duotone-group',
    SWAP_OPACITY: 'swap-opacity',
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
  };
  var prefixes = new Set();
  Object.keys(STYLE_TO_PREFIX[FAMILY_CLASSIC]).map(prefixes.add.bind(prefixes));
  Object.keys(STYLE_TO_PREFIX[FAMILY_SHARP]).map(prefixes.add.bind(prefixes));
  var RESERVED_CLASSES = [].concat(FAMILIES, _toConsumableArray(prefixes), ['2xs', 'xs', 'sm', 'lg', 'xl', '2xl', 'beat', 'border', 'fade', 'beat-fade', 'bounce', 'flip-both', 'flip-horizontal', 'flip-vertical', 'flip', 'fw', 'inverse', 'layers-counter', 'layers-text', 'layers', 'li', 'pull-left', 'pull-right', 'pulse', 'rotate-180', 'rotate-270', 'rotate-90', 'rotate-by', 'shake', 'spin-pulse', 'spin-reverse', 'spin', 'stack-1x', 'stack-2x', 'stack', 'ul', DUOTONE_CLASSES.GROUP, DUOTONE_CLASSES.SWAP_OPACITY, DUOTONE_CLASSES.PRIMARY, DUOTONE_CLASSES.SECONDARY]).concat(oneToTen.map(function (n) {
    return "".concat(n, "x");
  })).concat(oneToTwenty.map(function (n) {
    return "w-".concat(n);
  }));

  function bunker(fn) {
    try {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      fn.apply(void 0, args);
    } catch (e) {
      if (!PRODUCTION) {
        throw e;
      }
    }
  }

  var w = WINDOW || {};
  if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
  if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
  if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
  if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
  var namespace = w[NAMESPACE_IDENTIFIER];

  function normalizeIcons(icons) {
    return Object.keys(icons).reduce(function (acc, iconName) {
      var icon = icons[iconName];
      var expanded = !!icon.icon;

      if (expanded) {
        acc[icon.iconName] = icon.icon;
      } else {
        acc[iconName] = icon;
      }

      return acc;
    }, {});
  }

  function defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks,
        skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = normalizeIcons(icons);

    if (typeof namespace.hooks.addPack === 'function' && !skipHooks) {
      namespace.hooks.addPack(prefix, normalizeIcons(icons));
    } else {
      namespace.styles[prefix] = _objectSpread2(_objectSpread2({}, namespace.styles[prefix] || {}), normalized);
    }
    /**
     * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
     * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
     * for `fas` so we'll ease the upgrade process for our users by automatically defining
     * this as well.
     */


    if (prefix === 'fas') {
      defineIcons('fa', icons);
    }
  }

  var icons = {
    
    "beg-gear": [512,512,[],"e006","M265.4 501.8h-25.2c-23 0-41.4-12.8-41.4-29v-35c-12.4-3.8-23.9-8.5-35.4-14.5L138.7 448c-6 6-14.5 8.1-24.3 6c-9-1.7-17.9-6.8-25.2-14.5l-17.9-17.9c-7.3-7.3-12.8-16.6-14.5-25.2c-2.1-9.8 0-18.8 6-24.3l24.7-24.7c-6-11.1-11.1-23-14.5-35.4H37.5c-16.2 0-29-18.3-29-41.4v-25.2c0-23 12.8-41.4 29-41.4h35c3.8-12.4 8.5-23.9 14.5-35.4l-24.7-24.7c-6-6-8.1-14.5-6-24.3c1.7-9 6.8-17.9 14.5-25.2l17.9-17.9c7.3-7.3 16.6-12.8 25.2-14.5c9.8-2.1 18.3 0 24.3 6L163 92.6c11.1-6 23-11.1 35.4-14.5V42.7c0-16.2 18.3-29 41.4-29H265c23 0 41.4 12.8 41.4 29v35c12.4 3.8 23.9 8.5 35.4 14.5l24.7-24.7c11.5-11.5 33.3-7.7 49.9 8.5l17.9 17.9c16.2 16.2 20.1 38.4 8.5 49.9l-24.7 24.7c6 11.1 11.1 23 14.5 35.4h35c16.2 0 29 18.3 29 41.4v25.2c0 23-12.8 41.4-29 41.4H317c-8.1 9.8-18.8 17.5-30.3 22.2c-9 3.8-19.6 6.4-32 6.4c-.4 0-.9 0-1.3 0c0 0-.4 0-.4 0c-46.5-1.7-82.8-37.5-82.8-82.8s37.1-82.3 82.3-82.3c42.7 0 78.5 33.3 81.9 75.5c.4 3.4-2.1 6.8-6 6.8c-3.4 .4-6.4-2.1-6.8-6c-3-35.8-33.3-63.6-69.5-63.6c-38.4 0-69.5 31.1-69.5 69.5c0 38 30.7 68.7 70 69.5c9.8 .4 19.6-1.7 28.6-5.5c17.1-7.3 26-19.6 26.5-20.5c1.3-1.7 3-2.6 5.1-2.6h154.5c8.5 0 16.2-13.2 16.2-28.6v-25.2c0-15.4-7.7-28.6-16.2-28.6h-39.7c-3 0-5.5-2.1-6-4.7c-3.8-14.5-9.8-28.2-17.1-41.4c-1.3-2.6-.9-5.5 .9-7.7l28.2-28.2c6-6 2.1-20.9-8.5-31.6L407.5 85.3c-10.7-10.7-25.6-14.9-31.6-8.5L347.7 105c-2.1 2.1-5.1 2.6-7.7 .9c-13.2-7.7-26.9-13.2-41.4-17.1c-3-.9-4.7-3.4-4.7-6V42.7c0-8.5-13.2-16.2-28.6-16.2h-25.2c-15.4 0-28.6 7.7-28.6 16.2v39.7c0 3-2.1 5.5-4.7 6c-14.5 3.8-28.2 9.8-41.4 17.1c-2.6 1.3-5.5 .9-7.7-.9L129.7 76.8c-3.8-3.8-9.4-3-12.8-2.6c-6.4 1.3-13.2 5.5-18.8 11.1l-17.9 17.9c-5.5 5.5-9.8 12.4-11.1 18.8c-.9 3-1.3 9 2.6 12.8L99.8 163c2.1 2.1 2.6 5.1 .9 7.7c-7.7 13.2-13.2 26.9-17.1 41.4c-.9 3-3.4 4.7-6 4.7H37.5c-8.5 0-16.2 13.2-16.2 28.6v25.2c0 15.4 7.7 28.6 16.2 28.6h39.7c3 0 5.5 2.1 6 4.7c3.8 14.5 9.8 28.2 17.1 41.4c1.3 2.6 .9 5.5-.9 7.7L71.3 381c-3.8 3.8-3 9.4-2.6 12.8c1.3 6.4 5.5 13.2 11.1 18.8l17.9 17.9c5.5 5.5 12.4 9.8 18.8 11.1c3 .9 9 1.3 12.8-2.6l28.2-28.2c2.1-2.1 5.1-2.6 7.7-.9c13.2 7.7 26.9 13.2 41.4 17.1c3 .9 4.7 3.4 4.7 6v39.7c0 8.5 13.2 16.2 28.6 16.2H265c15.4 0 28.6-7.7 28.6-16.2v-39.7c0-3 2.1-5.5 4.7-6c14.5-3.8 28.2-9.8 41.4-17.1c2.6-1.3 5.5-.9 7.7 .9l28.2 28.2c3.8 3.8 9.4 3 12.8 2.6c6.4-1.3 13.2-5.5 18.8-11.1l17.9-17.9c10.7-10.7 14.9-25.6 8.5-31.6l-28.2-28.2c-2.6-2.6-2.6-6.4 0-9s6.4-2.6 9 0l28.2 28.2c11.5 11.5 7.7 33.3-8.5 49.9L416 439.9c-7.3 7.3-16.6 12.8-25.2 14.5c-9.8 2.1-18.8 0-24.3-6l-24.7-24.7c-11.1 6-23 11.1-35.4 14.5v35c.4 16.2-17.9 28.6-41 28.6z"],
    "beg-trash": [512,512,[],"e007","M300 482.4H184.8c-17.6 0-34.4-14.4-36.8-31.2c-8.8-74.4-51.2-294.4-51.2-296.8c0-.8 0-1.6 0-2.4c0-18.4 14.4-32.8 32.8-32.8h212c6.4 0 12 5.6 12 12S348 144 341.6 144h-212c-4.8 0-8 3.2-8.8 8c4 20 42.4 223.2 51.2 296.8c.8 4.8 7.2 10.4 12.8 10.4h116c5.6 0 12-4.8 12.8-10.4c8.8-73.6 48-279.2 51.2-296.8c0-1.6 0-3.2 0-5.6c0-4 .8-8 .8-10.4c0-28.8-43.2-55.2-100-60.8c-3.2 0-6.4-1.6-8-4.8c-2.4-2.4-3.2-5.6-2.4-8.8c0-.8 0-1.6 0-2.4c0-9.6-5.6-16.8-12.8-16.8s-12.8 8-12.8 16.8c0 .8 0 1.6 0 2.4c.8 3.2-.8 6.4-2.4 8.8c-2.4 2.4-4.8 4-8 4.8c-34.4 3.2-64 14.4-82.4 29.6c0 0 0 0-.8 0c-1.6 1.6-3.2 2.4-4.8 4c-4.8 4.8-12 4.8-16.8 0s-4.8-12 0-16.8c2.4-2.4 4-4 6.4-6.4c0 0 0 0 .8 0c20-16.8 50.4-28.8 84.8-33.6c3.2-19.2 17.6-34.4 36-34.4s32.8 15.2 36 34.4c65.6 9.6 111.2 42.4 111.2 83.2c0 2.4 0 8-.8 12c0 2.4 0 4.8 0 5.6s0 1.6 0 2.4c-.8 2.4-42.4 221.6-51.2 296.8c-2.4 16.8-19.2 30.4-37.6 30.4z"],
    "interior-light": [512,512,[],"e001","M492.2 510.2H22.4c-4.3 0-7.6-3.2-7.6-7.6c0 0 0-.4 0-.7l1.4-27s0-.4 0-.4c11.9-103.1 89.4-187.9 190.4-209.1c-2.5-6.5-4-13.7-4-20.9c0-22.7 14.1-42.5 34.6-50.8V21.6c0-9.7 7.9-17.7 17.7-17.7h4c9.7 0 17.7 7.9 17.7 17.7V194c20.6 7.9 34.6 28.1 34.6 50.8c0 7.2-1.4 14.1-4 20.9c96.3 20.2 171.3 97.4 188.2 195.1c.7 4-2.2 7.9-6.1 8.7s-7.9-2.2-8.7-6.1C464 368.5 389 294.6 294.6 278.7c-2.5-.4-4.7-2.2-5.8-4.3s-.7-5 .7-7.2c4.3-6.5 6.9-14.1 6.9-22c0-18-12.3-33.5-29.6-37.9c-2.2-.4-3.6-1.8-4.7-3.6s-1.4-4-.7-5.8c0-.4 0-.7 0-.7V21.6c0-1.4-1.1-2.5-2.5-2.5h-4c-1.4 0-2.5 1.1-2.5 2.5v174.9s0 .4 0 .7c.7 1.8 .4 4-.7 5.8s-2.9 3.2-4.7 3.6c-17.3 4.3-29.6 20.2-29.6 37.9c0 7.9 2.2 15.5 6.9 22c1.4 2.2 1.8 5 .7 7.2c-1.1 2.5-3.2 4-5.8 4.3c-98.8 16.9-176 98.1-187.5 197.9l-1.1 18.7h460.8c4.3-.4 8.7 2.9 8.7 7.6c-.4 4.3-4 7.9-7.9 7.9zM22.4 502.3l0 0 0 0z"],
    "pd11": [512,512,[],"e002","M355.2 255.2c-3.2 0-6.4-2.4-6.4-6.4v-13.6c-28 7.2-57.6 10.4-88 10.4c-33.6 0-66.4-4-96-12c-2.4-.8-4.8-3.2-4.8-5.6V192c0-1.6 .8-4 2.4-4.8s3.2-1.6 4.8-.8c28.8 8 60 11.2 92.8 11.2c31.2 0 60.8-3.2 88-10.4v-9.6c-57.6 14.4-128 13.6-184-1.6c-3.2-.8-4.8-4-4-7.2s4-4.8 7.2-4C224 180 296 180 352 164.8c1.6-.8 4 0 5.6 .8s2.4 3.2 2.4 4.8V192c0 2.4-1.6 4.8-4.8 5.6c-29.6 8-62.4 12-96 12c-30.4 0-60-3.2-88-9.6v23.2c56 14.4 125.6 14.4 180.8-1.6c1.6-.8 4 0 5.6 .8s2.4 3.2 2.4 4.8V248c1.6 4.8-1.6 7.2-4.8 7.2zM167.2 176c-3.2 0-6.4-2.4-6.4-6.4V116c0-8 6.4-15.2 14.4-15.2c2.4 0 64-6.4 85.6-6.4s83.2 6.4 86.4 6.4l0 0c7.2 0 14.4 6.4 14.4 15.2v32c0 3.2-2.4 6.4-6.4 6.4s-6.4-2.4-6.4-6.4v-32c0-1.6-1.6-3.2-2.4-3.2c-1.6 0-64.8-6.4-85.6-6.4s-84 6.4-84.8 6.4c-2.4 0-3.2 1.6-3.2 3.2v53.6c0 3.2-2.4 6.4-5.6 6.4zm94.4 156.8c-33.6 0-66.4-4-96-12c-2.4-.8-4.8-3.2-4.8-5.6v-64c0-1.6 .8-4 2.4-4.8s3.2-1.6 4.8-.8c28.8 8 60 11.2 92.8 11.2s63.2-4 92.8-11.2c3.2-.8 6.4 .8 7.2 4s-.8 6.4-4 7.2c-30.4 8-62.4 12-96 12c-30.4 0-60-3.2-88-9.6v52c27.2 7.2 57.6 10.4 88 10.4c25.6 0 50.4-4 73.6-8.8c4.8-.8 9.6-1.6 14.4-2.4v-27.2c0-3.2 2.4-6.4 6.4-6.4s6.4 2.4 6.4 6.4V316c0 3.2-2.4 5.6-4.8 5.6c-6.4 .8-12.8 2.4-19.2 3.2c-24 3.2-49.6 8-76 8zm0 79.2C184 412 128 390.4 128 361.6c0-13.6 8.8-24.8 26.4-32.8c3.2-1.6 6.4 0 8 3.2s0 6.4-3.2 8c-12.8 5.6-19.2 12.8-19.2 21.6c0 18.4 48.8 38.4 121.6 38.4s121.6-20 121.6-38.4c0-8-5.6-15.2-16.8-20.8c-32 9.6-68 14.4-104 14.4c-27.2 0-53.6-2.4-79.2-8c-3.2-.8-5.6-4-4.8-7.2s4-5.6 7.2-4.8c24.8 4.8 50.4 8 76.8 8c36 0 72-4.8 103.2-14.4c1.6-.8 3.2 0 4 0c17.6 8 26.4 19.2 26.4 32.8c-1.6 28.8-57.6 50.4-134.4 50.4zm191.2-30.4c-2.4 0-4.8-1.6-5.6-3.2c-1.6-3.2 0-6.4 3.2-8c20.8-9.6 23.2-62.4-5.6-125.6c-28-60.8-67.2-93.6-88-88.8c-3.2 .8-6.4-.8-7.2-4s.8-6.4 4-7.2c30.4-7.2 73.6 33.6 101.6 95.2c29.6 65.6 29.6 128 0 141.6c-.8 0-1.6 0-2.4 0zm-382.4 0c-.8 0-1.6 0-2.4-.8c-29.6-13.6-30.4-76 0-141.6c28-61.6 71.2-102.4 101.6-95.2c3.2 .8 4.8 4 4 7.2s-4 4.8-7.2 4c-20.8-4.8-60 27.2-88 88.8C49.6 308 52 360.8 72.8 369.6c3.2 1.6 4 4.8 3.2 8c-1.6 2.4-4 4-5.6 4z"],
    "pd4": [512,512,[],"e004","M256 450.4c-68.8 0-128.8-51.2-144-124c-.8-3.2 1.6-6.4 4.8-7.2s6.4 1.6 7.2 4.8c14.4 68 68.8 115.2 132 115.2c60.8 0 112.8-43.2 130.4-106.4c-36.8 6.4-82.4 10.4-130.4 10.4c-33.6 0-66.4-1.6-96-5.6c-3.2 0-5.6-3.2-5.6-6.4s3.2-5.6 6.4-5.6c28.8 3.2 61.6 5.6 94.4 5.6c51.2 0 100-4 137.6-12c1.6-.8 4 0 5.6 1.6s2.4 3.2 1.6 5.6c-16 72.8-75.2 124-144 124zm-.8-124c-73.6 0-183.2-12-183.2-44.8c0-10.4 10.4-19.2 32.8-27.2c3.2-.8 6.4 .8 8 4c.8 3.2-.8 6.4-4 8c-18.4 6.4-24.8 12-24.8 16c0 13.6 66.4 32.8 171.2 32.8c104 0 171.2-20 171.2-32.8c0-4-10.4-14.4-51.2-22.4c-3.2-.8-5.6-4-4.8-7.2s4-5.6 7.2-4.8c40.8 8 60.8 20 60.8 34.4c0 32-109.6 44-183.2 44zm219.2-19.2c-1.6 0-2.4-.8-4-1.6c-2.4-1.6-2.4-4.8-1.6-7.2c-1.6-4.8-12.8-20.8-38.4-41.6c-25.6-21.6-44-30.4-48-30.4c-3.2 .8-6.4 0-7.2-3.2c-1.6-3.2 0-6.4 2.4-8c12.8-6.4 49.6 23.2 60.8 32.8c12.8 11.2 24 22.4 32 32c7.2 8.8 14.4 19.2 8.8 25.6c-1.6 .8-3.2 1.6-4.8 1.6zm-92-80.8l0 0 0 0zM37.6 307.2c-1.6 0-3.2-.8-4.8-2.4c-5.6-6.4 .8-16.8 8.8-25.6c8-9.6 19.2-20.8 32-32c11.2-9.6 48-39.2 60.8-32.8c3.2 1.6 4 4.8 2.4 8c-1.6 2.4-4.8 4-7.2 3.2c-4 0-22.4 8.8-48 30.4s-36.8 37.6-38.4 41.6c.8 2.4 .8 5.6-1.6 7.2c-1.6 2.4-3.2 2.4-4 2.4zm91.2-80.8l0 0 0 0zm124.8 44c-44.8 0-88-4.8-121.6-13.6c-2.4-.8-4-3.2-4.8-5.6v-.8-.8l13.6-119.2c0-9.6 16-13.6 23.2-14.4V77.6c0-8 6.4-15.2 15.2-15.2h15.2c3.2 0 6.4 2.4 6.4 6.4v12.8c0 2.4-1.6 4.8-4 5.6c-5.6 2.4-9.6 8-9.6 14.4c0 8.8 7.2 16 16.8 15.2c5.6-.8 11.2-4.8 12.8-11.2c2.4-8-2.4-16-8.8-18.4c-2.4-.8-4-3.2-4-5.6V68c0-3.2 2.4-5.6 5.6-6.4h33.6l0 0c3.2 0 5.6 2.4 5.6 4.8c.8 3.2-.8 5.6-4 6.4c-3.2 1.6-6.4 4-6.4 14.4c0 8 6.4 15.2 15.2 15.2s16-6.4 16-14.4c0-10.4-3.2-12.8-6.4-14.4c-2.4-.8-4-4-4-6.4c.8-3.2 3.2-4.8 5.6-4.8l0 0h33.6c3.2 0 5.6 2.4 5.6 6.4v12.8c0 2.4-1.6 4.8-4 5.6c-5.6 2.4-9.6 8-9.6 14.4c0 8 6.4 15.2 15.2 15.2c8 0 15.2-6.4 15.2-15.2c0-6.4-4-12-9.6-14.4c-2.4-.8-4-3.2-4-5.6V68c0-3.2 2.4-6.4 6.4-6.4h15.2c8 0 15.2 6.4 15.2 15.2v38.4c7.2 .8 23.2 4.8 23.2 15.2L382.4 248c0 3.2-1.6 6.4-5.6 6.4c-3.2 .8-6.4-1.6-6.4-5.6l-13.6-117.6c-2.4-1.6-9.6-4-13.6-4h-4c-3.2 0-6.4-2.4-6.4-6.4v-13.6c-3.2 12-13.6 20-26.4 20c-13.6 0-24.8-10.4-26.4-23.2c-1.6-11.2 3.2-21.6 13.6-27.2V73.6H280c.8 2.4 1.6 4 1.6 6.4c3.2 16.8-9.6 34.4-26.4 34.4c-15.2 0-27.2-12-27.2-27.2c0-5.6 .8-9.6 2.4-13.6H216v3.2c12.8 7.2 19.2 24.8 8 39.2c-4.8 6.4-12 10.4-20 11.2c-13.6 .8-24.8-8-28-20.8V120c0 3.2-2.4 6.4-6.4 6.4h-4c-3.2 0-11.2 2.4-13.6 4l-13.6 114.4c32 8 72 12 113.6 12c25.6 0 50.4-1.6 73.6-4.8l12-1.6c3.2-.8 6.4 1.6 7.2 4.8s-1.6 6.4-4.8 7.2L327.2 264c-22.4 4.8-48 6.4-73.6 6.4zM356.8 131.2l0 0 0 0zm-204 0l0 0 0 0zm26.4-56.8c-1.6 0-3.2 1.6-3.2 3.2v16.8c1.6-7.2 6.4-12.8 12.8-16.8V74.4l-9.6 0zm142.4 3.2c6.4 4 10.4 9.6 12.8 16.8V77.6c0-1.6-1.6-3.2-3.2-3.2h-9.6s0 3.2 0 3.2z"],
    "pd9": [512,512,[],"e003","M320.8 300h-168c-7.2 0-12.8-4.8-12.8-11.2V280c0-6.4 5.6-11.2 12.8-11.2h4V130.4c0-7.2 6.4-13.6 13.6-13.6h40.8c3.2 0 6.4 2.4 6.4 6.4v26.4c0 .8 .8 1.6 1.6 1.6h70.4c.8 0 1.6-.8 1.6-1.6v-26.4c0-3.2 2.4-6.4 6.4-6.4h40c7.2 0 13.6 6.4 13.6 13.6V268h4c7.2 0 12.8 4.8 12.8 11.2v14.4c0 3.2-2.4 6.4-6.4 6.4s-6.4-2.4-6.4-6.4v-12.8h-.8-9.6c-3.2 0-6.4-2.4-6.4-6.4v-144c0-.8-.8-1.6-1.6-1.6h-34.4v20c0 7.2-6.4 13.6-13.6 13.6h-70.4c-7.2 0-13.6-6.4-13.6-13.6v-20h-35.2c-.8 0-1.6 .8-1.6 1.6v144c0 3.2-2.4 6.4-6.4 6.4H152c-.8 0-.8 0-.8 0V288h.8 168c3.2 0 6.4 2.4 6.4 6.4s-2.4 5.6-5.6 5.6zm-68 40.8c-76 0-146.4-15.2-188-41.6c-2.4-1.6-3.2-4-2.4-6.4s3.2-4 5.6-4h45.6c3.2 0 6.4 2.4 6.4 6.4s-2.4 6.4-6.4 6.4H92.8c40 18.4 98.4 28.8 160.8 28.8s120-10.4 160.8-28.8h-52c-3.2 0-6.4-2.4-6.4-6.4s2.4-6.4 6.4-6.4h76c2.4 0 4.8 1.6 5.6 4s0 5.6-2.4 6.4c-42.4 26.4-112.8 41.6-188.8 41.6zM327.2 300h-176c-3.2 0-6.4-2.4-6.4-6.4s2.4-6.4 6.4-6.4h176c3.2 0 6.4 2.4 6.4 6.4s-3.2 6.4-6.4 6.4zM252.8 403.2c-34.4 0-65.6-20.8-78.4-52.8c-1.6-3.2 0-6.4 3.2-8s6.4 0 8 3.2c11.2 27.2 37.6 44.8 67.2 44.8c26.4 0 49.6-13.6 62.4-35.2c-34.4 4-72 4.8-107.2 1.6c-3.2 0-5.6-3.2-5.6-6.4s3.2-5.6 6.4-5.6c38.4 3.2 79.2 2.4 116-3.2c2.4 0 4 .8 5.6 2.4s1.6 4 .8 5.6c-12.8 32.8-44 53.6-78.4 53.6zm140.8-120c-2.4 0-4.8-1.6-5.6-3.2c-1.6-3.2 0-6.4 3.2-8c6.4-2.4 9.6-12.8 9.6-27.2c0-16.8-4.8-36-13.6-56c-17.6-40-43.2-63.2-56.8-60c-3.2 .8-6.4-1.6-7.2-4.8s1.6-6.4 4.8-7.2c21.6-5.6 51.2 23.2 71.2 66.4c9.6 21.6 14.4 43.2 14.4 60.8c0 20-5.6 33.6-16.8 38.4c-1.6 .8-2.4 .8-3.2 .8zm-284 0c-.8 0-1.6 0-2.4-.8c-21.6-9.6-22.4-52-2.4-99.2c19.2-44 48.8-72 71.2-66.4c3.2 .8 5.6 4 4.8 7.2s-4 5.6-7.2 4.8c-13.6-3.2-39.2 20-56.8 60c-18.4 42.4-16.8 77.6-4 83.2c3.2 1.6 4.8 4.8 3.2 8c-1.6 1.6-4 3.2-6.4 3.2z"],
    "relais": [512,512,[],"e005","M248.7 491.9c-5.5 0-9.1-3.7-9.1-9.1V351.1L360.2 139c1.8-3.7 7.3-5.5 12.8-3.7c3.7 1.8 5.5 7.3 3.7 12.8l-117 208.5v126.2c-1.8 5.5-7.3 9.1-11 9.1zm11-320c-5.5 0-9.1-3.7-9.1-9.1V31.1c0-5.5 3.7-9.1 9.1-9.1s9.1 3.7 9.1 9.1v131.7c0 5.5-5.5 9.1-9.1 9.1z"]

  };
  var prefixes$1 = [null    ,'fak',
    ,'fa-kit'

  ];
  bunker(function () {
    var _iterator = _createForOfIteratorHelper(prefixes$1),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prefix = _step.value;
        if (!prefix) continue;
        defineIcons(prefix, icons);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });

}());
